import { analytics, useUser } from 'libs';
import { Select } from 'components/common';
import Filter from './Filter';

interface RateHoldOption {
  label: string;
  value: string;
}

const options: RateHoldOption[] = [
  { label: '30 Days', value: '30' },
  { label: '45 Days', value: '45' },
  { label: '60 Days', value: '60' },
  { label: '90 Days', value: '90' },
  { label: '120 Days', value: '120' },
  { label: '6 Months', value: '180' },
  { label: '12 Months', value: '365' },
];

interface RateHoldFilterProps {
  filters: { rate_hold?: number | string };
  isPro?: boolean;
  onFilter: (update: { rate_hold: string | null }) => void;
}

const RateHoldFilter = ({ filters, isPro = false, onFilter }: RateHoldFilterProps) => {
  const user = useUser();
  const disabled = isPro && !user.features.is_pro;

  const onChange = (selected: RateHoldOption | null) => {
    const filter = { rate_hold: selected?.value || null };

    analytics.productSearch.filter({
      rate_hold: filter.rate_hold || 'cleared',
    });
    onFilter(filter);
  };

  return (
    <Filter name="Rate Hold" isPro={isPro}>
      <Select
        className="form-react-select"
        clearValue={null}
        disabled={disabled}
        onChange={onChange}
        options={options}
        placeholder="All"
        selected={options.find((option) => option.value === String(filters.rate_hold)) || null}
        testId="filter-rate-hold"
      />
    </Filter>
  );
};

export default RateHoldFilter;
